import { ReactComponent as IconMyPersona } from "@/assets/svgs/My-persona.svg"
import { ReactComponent as IconChevronDown } from "@/assets/svgs/chevron-down.svg"
import { ReactComponent as IconChevronRight } from '@/assets/svgs/chevron-right.svg'
import { ReactComponent as IconClose } from '@/assets/svgs/icon-close.svg'
import { ReactComponent as IconData, ReactComponent as IconDataElement, ReactComponent as IconDefaultDataElement } from '@/assets/svgs/icon-data.svg'
import { ReactComponent as IconGear } from '@/assets/svgs/icon-gear.svg'
import { ReactComponent as IconPitstop } from '@/assets/svgs/icon-pitstop.svg'
import { ReactComponent as IconSearch } from '@/assets/svgs/icon-search.svg'
import { ReactComponent as IconTick } from '@/assets/svgs/tick.svg'
import Breadcrumbs from '@/components/Breadcrumbs'
import Button from '@/components/Button'
import CardConfigure from '@/componentsDS/Modal/CardConfigure'
import DropdownContributor from "@/components/DropdownContributor/index"
import Input from '@/components/Input/index'
import Modal from '@/componentsDS/Modal/Modal'
import Popover from '@/components/Popover'
import Portal from '@/components/Portal'
import SelectorBox2 from '@/components/SelectorBox2'
import SelectorBox3 from '@/components/SelectorBox3'
import StepList from '@/components/StepList/index'
import Toast from '@/components/Toast'
import { EnrolmentTypes } from '@/constants/use-case'
import useDataElements from '@/hooks/use-data-elements'
import useDataElementDetails from "@/hooks/use-data-elements-details"
import useModal from '@/hooks/use-modal'
import usePage from '@/hooks/use-page'
import usePersona from '@/hooks/use-personas'
import usePitstop from '@/hooks/use-pitstop/index'
import usePrincipals from "@/hooks/use-principal/index"
import useStepList from '@/hooks/use-step-list'
import useSystem from '@/hooks/use-sys/index'
import useToast from '@/hooks/use-toast'
import { useNavigate, useParams } from '@/lib/router-dom/index'
import PrincipalTableList from "@/pages/use-cases/agent-principal/principal-table"
import API_ENROLMENTS from '@/services/api/enrolment'
import rem from '@/utils/rem'
import titleCase from '@/utils/title-case'
import { getSystemList, isSubmitBtnDisabled } from '@/utils/use-case'
import { getUseCaseId } from "@/utils/use-case-storage"
import classname from 'classnames'
import produce from 'immer'
import { orderBy } from 'lodash'
import PropTypes from "prop-types"
import { Fragment, useEffect, useMemo, useState } from 'react'
import Loader from 'react-loader-spinner'
import { useSelector } from 'react-redux'
import PersonaInfoModal from '../components/PersonaInfoModal/index'
import Stepper from "@/componentsDS/Stepper/Stepper"
import { feature } from "@/utils/feature-verifier"
import { featureConstant } from "@/constants/configuration/feature"

const Page = () => {

	/*=================================================
		General
	/================================================*/

	const { useCaseId, enrolmentType } = useParams()

	const useCase = useMemo(() => getUseCaseId(useCaseId), [useCaseId]);

	const user = useSelector(state => state.auth.user)

	const toastType = {
		success: "success",
		error: "error"
	}

	const statuses = {
		approved: "APPROVED",
		rejected: "REJECTED",
		revoked: "REVOKED",
		pending: "PENDING"
	}

	const [pageTitle] = useState('Initiate Data Element Sharing')
	const [subPageTitle] = useState(useCase.name)

	const { breadcrumbsItems } = usePage({ title: pageTitle, breadcrumbs: ['Explore Use Cases', subPageTitle, pageTitle] })

	const { goTo } = useNavigate()

	const [required, setRequired] = useState(false)
	const [optional, setOptional] = useState(false)

	const [loading, setLoading] = useState(false)

	const [isEnrolmentOfPrincipal, setIsEnrolmentOfPrincipal] = useState(false)

	const [selectedPersona, setSelectedPersona] = useState()

	const [selectedDataElement, setSelectedDataElement] = useState()

	useEffect(() => {
		if ((enrolmentType === 'consume_on_behalf_of_principal' || enrolmentType === 'provide_on_behalf_of_principal'))
			setIsEnrolmentOfPrincipal(true)
	}, [])

	/*=================================================
		API
	/================================================*/

	const { toastList, addToastMessage } = useToast()

	const { find: findDataElements, items: dataElementsItems, setItems: setDataElements, currentItem: currentDataElement, setCurrentItem: setCurrentDataElement, view: viewDataElement, error: errorDataElement, loading: loadingDataElement } = useDataElements()
	const { find: findPersonas, findAndSetCurrentPersona, fetch: fetchPersonas, currentItem: currentPersonaItem, items: personaItems, setItems: setPersonaItems, view: viewPersona, error: errorPersona, loading: loadingPersona } = usePersona()
	const { find: findSys, items: systemItems, setItems: setSystem, view: viewSystem, currentItem: currenSystemItem, error: errorSystem } = useSystem()
	const {
		currentItem,
		setCurrentItem,
		fetchDataElementsDetail,
		error,
	} = useDataElementDetails();

	const { items: pitstopItems, fetch: fetchPitstop } = usePitstop()

	const { fetch: fetchPrincipals, items: principalItems, setItems: setPrincipalItems, meta } = usePrincipals(
		{ cacheFetchedItem: { identifier: 'id', keys: ['$selected'] } }
	)

	const isAgentPrincipalPhase2Enabled = feature(featureConstant.AGENT_PRINCIPAL_PHASE_2)

	const fetchEnrollPersona = {
		useCaseId: useCaseId,
		orgId: user.organizationId
	}

	useEffect(async () => {
		async function getData() {

			const dataPersonasTemp = produce(await findPersonas(fetchEnrollPersona), draft => {
				return orderBy(draft, [option => option.name], "asc")
			})

			setPersonaItems(dataPersonasTemp)
		}

		try {
			await getData()
			await fetchPitstop()
		} catch (err) {
			console.error({ err });
		}
	}, [])

	useEffect(() => {
		addToastMessage(errorDataElement, toastType.error)
	}, [errorDataElement])

	useEffect(() => {
		addToastMessage(errorPersona, toastType.error)
	}, [errorPersona])

	useEffect(() => {
		addToastMessage(errorSystem, toastType.error)
	}, [errorSystem])

	const pitstopList = pitstopItems?.map((item) => {
		return {
			id: item.systemId,
			name: item.systemName
		}
	})

	/*=================================================
		Step
	/================================================*/
	const defaultStepsArr=[
		{stepTitle: 'Choose Persona'},
		{stepTitle: 'Choose Data Element'},
		{stepTitle: 'Choose Pitstop'},
		{stepTitle: 'Review & Confirm'}
	]
	const secondStepArr=[
		{stepTitle:'Basic Configuration'},
		{stepTitle:'Choose Pitstop'},
		{stepTitle:'Choose Principal'},
		{stepTitle:'Review & Confirm'}
	]

	const [steps, setSteps] = useState([...defaultStepsArr])

	const { step, goToStep, prevStep, nextStep } = useStepList(steps)

	useEffect(() => {
		if (isEnrolmentOfPrincipal)
			setSteps([...secondStepArr])
	}, [isEnrolmentOfPrincipal])

	/*=================================================
		Modal
	/================================================*/

	const { visible: visiblePersonaInfo, show: showPersonaInfo, hide: hidePersonaInfo } = useModal()
	const { visible: visibleDataElementInfo, show: showDataElementInfo, hide: hideDataElementInfo } = useModal()
	const { visible: visibleSystemInfo, show: showSystemInfo, hide: hideSystemInfo } = useModal()
	const { visible: IsVisibleCancel, show: showCancel, hide: hideCancel } = useModal()

	/*=================================================
		Search
	/================================================*/

	const [searchBoxValue, setSearchBoxValue] = useState("")

	function handleSearch(e) {
		setSearchBoxValue(e.target.value)
	}

	/*=================================================
		Sort
	/================================================*/

	const pageLimit = 10;
	const [sortConfig, setSortConfig] = useState({ sortBy: "name", direction: 'asc' });

	function handleSort(sortBy) {
		let direction = sortConfig.direction;
		if (sortConfig.sortBy === sortBy) {
			direction = !direction;
		} else {
			direction = true;
		}

		setSortConfig({ sortBy, direction });
	}

	/*=================================================
		Principal List & Pagination
	/================================================*/

	function getSortedData(_searchTerm = searchBoxValue, sortBy = sortConfig?.sortBy, direction = sortConfig?.direction) {
		if (isEnrolmentOfPrincipal) {
			fetchPrincipals({
				search: _searchTerm?.length > 0 ? _searchTerm : null,
				sortBy: sortBy?.length > 0 ? sortBy : null,
				direction: sortBy ? (direction ? "asc" : "desc") : null,
			})
		}
	}

	/*=================================================
		Basic Configuration
	/================================================*/

	const BasicConfiguration = ({ personaItem, dataElementItem }) => {
		const filterPersonaItem = personaItem?.filter(item => item?.status === statuses.approved)

		async function handleCheckPersonaInfo(item) {
			await findAndSetCurrentPersona({ personaId: item.id, useCaseId: useCaseId })
			showPersonaInfo()
		}

		async function handleCheckDataElementInfo(item) {
			viewDataElement(item.id)
			showDataElementInfo()
		}

		const handleUpdatePersonaSelect = async (item) => {
			setSelectedPersona(item)
			viewPersona(item.id)

			const index = personaItems?.findIndex(persona => persona.id === item.id);
			const updatedItems = produce(personaItems, draft => {
				draft.forEach(
					personaItems => personaItems.$selected = false
				)
				draft[index].$selected = !draft[index].$selected
			})

			setPersonaItems(updatedItems)

			await fetchDataElement(item.id)
			setSelectedDataElement('')
		}

		const handleUpdateDataElementSelect = (item) => {
			setSelectedDataElement(item)
			viewDataElement(item.id)

			const index = dataElementsItems?.findIndex(dataElement => dataElement.id === item.id);
			const updatedItems = produce(dataElementsItems, draft => {
				draft.forEach(
					dataElementsItems => dataElementsItems.$selected = false
				)
				draft[index].$selected = !draft[index].$selected
			})

			setDataElements(updatedItems)
			setSystem([])
		}

		function DropDownListLoading() {
			return (
				<div className='dropdown__button dropdown__button--modified dropdown__button--disabled enrolment-request__dropdown-container__loading'>
					<Loader
						className="loadingSpinner__position__center"
						data-testid="loadingSpinner__position__center"
						type="ThreeDots"
						color="grey"
						height={10}
						width={15}
					/>
				</div>
			)
		}

		const personaList = (
			<div className='layout-data-elements__warpper'>
				<div className='layout-data-elements__lable'>* Persona</div>
				<div>
					{loadingPersona ? (
						<DropDownListLoading />
					) : (
						<>
							{filterPersonaItem?.length > 0 ? (
								<div className="layout-data-elements__content__dropdown">
									<div className="enrolment-request__dropdown-container">
										<DropdownContributor
											full
											options={filterPersonaItem}
											value={selectedPersona ? selectedPersona?.name : "Select Persona"}
											submit={(option) => {
												handleUpdatePersonaSelect(option)
											}}
											handleCheckInfo={(item) => {
												handleCheckPersonaInfo(item)
											}}
										/>
									</div>
								</div>
							) : (
								<div className='request-enrolment-selectors__col'>No persona to enroll</div>
							)}
						</>
					)}
				</div>
			</div>
		)

		const dataElementList = (
			<div className='layout-data-elements__warpper'>
				<div className='layout-data-elements__lable'>* Data Element</div>
				<div>
					{loadingDataElement || loadingPersona ? (
						<DropDownListLoading />
					) : (
						dataElementItem?.length === 0 && personaItems?.some(item => item.$selected === true) ? (
							<div className='request-enrolment-selectors__col'>No data elements to enroll</div>
						) : (
							<div className="layout-data-elements__content__dropdown">
								<div className="enrolment-request__dropdown-container">
									<DropdownContributor
										full
										options={dataElementItem}
										value={selectedDataElement ? selectedDataElement?.name : "Select Data Element"}
										submit={(option) => {
											handleUpdateDataElementSelect(option)
										}}
										handleCheckInfo={(item) => {
											handleCheckDataElementInfo(item)
										}}
										disabled={
											!personaItems?.some(item => item.$selected === true)
										}
									/>
								</div>
							</div>
						)
					)}
				</div>
			</div>
		)

		return (
			<div style={{ width: "45%" }}>
				<div className="layout-data-elements__content__text">
					{personaList}
					{dataElementList}
				</div>
			</div>
		)
	}

	BasicConfiguration.propTypes = {
		personaItem: PropTypes.array.isRequired,
		dataElementItem: PropTypes.array.isRequired,
	}

	/*=================================================
		Persona List
	/================================================*/

	const PersonaList = ({ dataItem }) => {

		async function handleCheckInfo(item) {
			await findAndSetCurrentPersona({ personaId: item.id, useCaseId: useCaseId })
			showPersonaInfo()
		}

		const handleUpdateSelect = (item) => {
			const index = personaItems?.findIndex(persona => persona.id === item.id);
			const updatedItems = produce(personaItems, draft => {
				draft.forEach(
					personaItems => personaItems.$selected = false
				)
				draft[index].$selected = !draft[index].$selected
			})

			setPersonaItems(updatedItems)
		}

		const list = dataItem?.filter(item => item?.status === statuses.approved).map((persona, index) => {
			return (
				<div className="request-enrolment-selectors__col" key={index}>
					<SelectorBox3 label={persona?.name}
						// description={persona?.description}
						submit={() => {
							viewPersona(persona.id)
							handleUpdateSelect(persona)
						}}
						active={persona?.$selected}
						handleCheckInfo={() => handleCheckInfo(persona)}
					/>
				</div>
			)
		})

		return (
			<div className='request-enrolment-selectors__cols'>
				{list.length > 0 ? list : <div className='request-enrolment-selectors__col'>No persona to enroll</div>}
			</div>
		)
	}

	/*=================================================
		Data Elemental List
	/================================================*/

	const DataElementList = ({ dataItem }) => {

		async function handleCheckInfo(item) {
			viewDataElement(item.id)
			showDataElementInfo()
		}

		const handleUpdateSelect = (item) => {
			const index = dataElementsItems?.findIndex(dataElement => dataElement.id === item.id);
			const updatedItems = produce(dataElementsItems, draft => {
				draft.forEach(
					dataElementsItems => dataElementsItems.$selected = false
				)
				draft[index].$selected = !draft[index].$selected
			})

			setDataElements(updatedItems)
		}

		const list = dataItem?.map((dataElement, index) => {
			return (
				<div className="request-enrolment-selectors__col" key={index}>
					<SelectorBox3 label={dataElement?.name}
						// description={dataElement?.description}
						submit={() => {
							viewDataElement(dataElement.id)
							handleUpdateSelect(dataElement)
						}}
						active={dataElement?.$selected}
						handleCheckInfo={() => handleCheckInfo(dataElement)}
					/>
				</div>
			)
		})

		return (
			<div className='request-enrolment-selectors__cols'>
				{list.length > 0 ? list : <div className='request-enrolment-selectors__col'>No data elements to enroll</div>}
			</div>
		)
	}

	/*=================================================
		System List
	/================================================*/

	const SystemList = ({ dataItem }) => {
		const updatedSystem = currentItem?.system.filter(obj => obj.enrolStatus === "APPROVED");
		const updatedPitstopArray = dataItem?.filter(objFromA => !updatedSystem?.find(objFromB => {
			return objFromA.id === objFromB.id
		}))

		async function handleCheckInfo(item) {
			viewSystem(item.id)
			showSystemInfo()
		}

		const handleUpdateSelect = (item) => {
			const index = systemItems?.findIndex(sys => sys.id === item.id);
			const updatedItems = produce(systemItems, draft => {
				draft[index].$selected = !draft[index].$selected
			})

			const updatedSysList = getSystemList(
				updatedItems,
				pitstopList,
				enrolmentType,
			);

			setSystem(updatedSysList)
		}

		const list = updatedPitstopArray?.map((sys, index) => {
			return (
				<div className="request-enrolment-selectors__col" key={index}>
					<SelectorBox2 label={sys?.systemName}
						sublabel={sys?.organisation.name}
						image={sys?.organisation.iconUrl}
						submit={() => {
							handleUpdateSelect(sys)
						}}
						active={sys?.$selected}
						handleCheckInfo={() => handleCheckInfo(sys)}
					/>
				</div>
			)
		})

		return (
			<div className='request-enrolment-selectors__cols'>
				{list.length > 0 ? list : <div className='request-enrolment-selectors__col'>No pitstops to enroll</div>}
			</div>
		)
	}

	/*=================================================
		Confirmation
	/================================================*/

	const selectedSystem = systemItems.filter(sys => sys.$selected)
	const providerPitstopList = selectedSystem?.filter((sys) => {
		return !pitstopList?.some(pitstop => {
			return sys.id === pitstop.id
		})
	})

	function updateCopyToContributor(item) {
		const index = systemItems?.findIndex(sys => sys.id === item.id);
		const updatedItems = produce(systemItems, draft => {
			draft[index].$ccToContributor = !draft[index].$ccToContributor

			if (pitstopList?.length === 1 && draft[index].$ccToContributor) {
				draft[index].contributorSystemId = pitstopList[0].id
			}

			if (!draft[index].$ccToContributor) {
				draft[index].contributorSystemId = undefined
				draft[index].contributorSystemName = ""
				draft[index].$sysOptionsVisible = false
			}
		})

		setSystem(updatedItems)
	}

	function updateDropdownVisibility(item) {
		const index = systemItems?.findIndex(sys => sys.id === item.id);
		const updatedItems = produce(systemItems, draft => {
			draft[index].$sysOptionsVisible = !draft[index].$sysOptionsVisible
		})

		setSystem(updatedItems)
	}

	function handleSelectedPitstop(option, item) {
		const index = systemItems?.findIndex(sys => sys.id === item.id);
		const updatedItems = produce(systemItems, draft => {
			draft[index].$sysOptionsVisible = !draft[index].$sysOptionsVisible
			draft[index].contributorSystemId = option.id
			draft[index].contributorSystemName = option.name
		})

		setSystem(updatedItems)
	}

	const requiredAction = classname({
		'enrolment-request-field-action': true,
		'enrolment-request-field-action--active ': required
	})

	const optionalAction = classname({
		'enrolment-request-field-action': true,
		'enrolment-request-field-action--active': optional
	})

	const Checkbox = ({ selected, handleUpdateItemSelect, disabled }) => {
		const pitstopCheckBoxClass = classname({
			"use-case-request__checkbox": true,
			"use-case-request__checkbox--active": selected,
			"use-case-request__checkbox--disabled": disabled,
		})

		return (
			<div data-testid='checkbox-element' className={pitstopCheckBoxClass} onClick={handleUpdateItemSelect} >{selected ? <IconTick /> : null}</div>
		)
	}

	const Confirmation = () => {

		const RequestFields = ({ field, schema, showBoldText }) => {
			if (!Array.isArray(field)) {
				return ""
			}

			const items = field.map((item, index) => {
				return (
					<div className="container-content-item__col" key={index}>
						<span>{item.name}</span>
					</div>
				)
			})
			return items;
		}

		const renderSelectedRow = (items) => {
			return items?.length && items.filter((s) => s.$selected === true).map((s, index) => {
				return (
					<Fragment key={index}>
						<div className="layout-request__tile__content__row">
							<div className="layout-request__tile__content__col">
								<div
									className="layout-request__tile__content__avatar "
									style={{
										backgroundImage: `url(${s?.organisation?.iconUrl})`,
									}}
								>
									{!s?.organisation?.iconUrl && <IconPitstop />}
								</div>
								<div className="enrolment-request__content__system-info">
									<div className="enrolment-request__systme-name">
										{s?.name}
									</div>
									{s?.uen ? <div className="enrolment-request__principal-UEN">UEN: {s?.uen}</div> : ''}
									{enrolmentType.toUpperCase() === EnrolmentTypes.provider && !pitstopList?.some(pitstop => pitstop.id === s.id) &&
										(
											<div className="enrolment-request__system-selection">
												<div className="enrolment-request__system-selection-checkbox">
													<Checkbox selected={s.$ccToContributor} handleUpdateItemSelect={() => updateCopyToContributor(s)} />
												</div>
												<div className="enrolment-request__system-selection-description">
													<span>Send transaction copies to Pitstop&nbsp;</span>
													{pitstopList?.length === 1 && (
														<span className="enrolment-request__system-selection-description--bold">{`"${pitstopList[0].name}"`}</span>
													)}
												</div>
												{pitstopList?.length > 1 && (
													<div className="enrolment-request__dropdown-container">
														<Popover visible={s.$sysOptionsVisible}>
															<Popover.Trigger>
																<div data-testid='pitstop-dropdow' className="enrolment-request__dropdown enrolment-request__dropdown-pitstop" onClick={() => updateDropdownVisibility(s)}>
																	<div className="enrolment-request__dropdown-placeholder">{s.contributorSystemName ? s.contributorSystemName : "Select Pitstop"}</div>
																	<div><IconChevronDown /></div>
																</div>
															</Popover.Trigger>

															<Popover.Content>
																<div className="enrolment-request__dropdown-content enrolment-request__dropdown-content__pitstop">
																	{pitstopList?.map((option) => (
																		<div className="enrolment-request__dropdown-item" key={option.id} onClick={() => { handleSelectedPitstop(option, s) }}>
																			{option.name}
																		</div>
																	))}
																</div>
															</Popover.Content>
														</Popover>
													</div>
												)}
											</div>
										)
									}
								</div>
							</div>
						</div>
					</Fragment>
				);
			});
		}

		return (
			<div className="enrolment-request_confirmation__container">
				<div className="layout-request-block enrolment-request_confirmation_left">
					<div className="layout-request__tiles">
						<div className="layout-request__tile">
							<div className="layout-request__tile__content">
								<div className="layout-request__tile__content__header request-enrolment-confirmation-header">
									<div className="layout-request__title__content__header__left">
										<div className="request-enrolment-confirmation-header-title">
											Selected Data Element
										</div>
									</div>
									<div className="layout-request__title__content__header__right">
										<Button text="Edit" ghost submit={() => {
											goToStep(1)
										}} />
									</div>
								</div>
								<div className="enrolment-request__tile__content">
									<div className="layout-request__tile__content__sub__header enrolment-request__tile__content__sub__header">
										<div className="layout-request__tile__content__sub__header__icon layout-request__tile__content__sub__header__icon--purple">
											<IconDefaultDataElement />
										</div>
										<div className="enrolment-request__tile__content__sub__header__text">
											<div className="layout-request__tile__content__sub__header__text__top">
												<div className="request-title">
													{currentDataElement?.name}
												</div>
											</div>
											<div className="layout-request__tile__content__sub__header__text__bottom">
												<div className="request-title-sub__text">
													{titleCase(getTypeName())}
												</div>
											</div>
										</div>
									</div>
									<div className="layout-request__tile__content__sub__header enrolment-request__tile__content__sub__header">
										<div className="enrolment-request__tile__content__sub__header__text">
											<div className="layout-request__tile__content__sub__header__text__top">
												<div className="request-title-sub__text--link request-title-sub__text--grey80">
													<span data-testid="datafld">Data Fields</span>
												</div>
											</div>
										</div>
									</div>
									<div className="layout-request__tile__content__sub__header enrolment-request__tile__content__sub__header">
										<div className="enrolment-request__tile__content__sub__header__text">
											<div className="layout-request__tile__content__sub__header__text__top">
												<div className="layout-request__tile__content__sub__header__text__top__left">
													<div className="request-title-sub__text--link">
														<span>Required</span>
													</div>
												</div>
												<div className="layout-request__tile__content__sub__header__text__top__right">
													<span className="enrolment-request-field-count">
														{currentDataElement?.requiredFields.length}
													</span>
													<span data-testid="expand-required-field" className={requiredAction} onClick={() => setRequired(!required)}>
														<IconChevronRight />
													</span>
												</div>
											</div>
											<div className="enrolment-request__tile__content__sub__header__text__bottom">
												{
													required && (
														<RequestFields field={currentDataElement?.requiredFields} />
													)
												}
											</div>
										</div>
									</div>
									<div className="layout-request__tile__content__sub__header enrolment-request__tile__content__sub__header">
										<div className="enrolment-request__tile__content__sub__header__text">
											<div className="layout-request__tile__content__sub__header__text__top">
												<div className="layout-request__tile__content__sub__header__text__top__left">
													<div className="request-title-sub__text--link">
														<span>Optional</span>
													</div>
												</div>
												<div className="layout-request__tile__content__sub__header__text__top__right">
													<span className="enrolment-request-field-count">
														{currentDataElement?.optionalFields.length}
													</span>
													<span data-testid="expand-optional-field" className={optionalAction} onClick={() => setOptional(!optional)}>
														<IconChevronRight />
													</span>
												</div>
											</div>
											<div className="enrolment-request__tile__content__sub__header__text__bottom">
												{
													optional && (
														<RequestFields field={currentDataElement?.optionalFields} />
													)
												}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="layout-request-block enrolment-request__right-block enrolment-request_confirmation_right">
					<div className="layout-request__tiles">
						{!isEnrolmentOfPrincipal &&
							<div className="layout-request__tile">
								<div className="layout-request__tile__content">
									<div className="layout-request__tile__content__header request-enrolment-confirmation-header">
										<div className="layout-request__title__content__header__left">
											<div className="request-title request-enrolment-confirmation-header-title">
												Selected Data Element
											</div>
										</div>
										<div className="layout-request__title__content__header__right">
											<Button text="Edit" ghost submit={() => {
												goToStep(2)
											}} />
										</div>
									</div>
									<div className="enrolment-request__tile__content">
										<div className="layout-request__tile__content__sub__header">
											<div className="layout-request__tile__content__sub__header__icon layout-request__tile__content__sub__header__icon--white">
												<IconDataElement />
											</div>
											<div className="enrolment-request__tile__content__sub__header__text">
												<div className="layout-request__tile__content__sub__header__text__top">
													<div className="request-title">
														{currentDataElement?.name}
													</div>
												</div>
												<div className="layout-request__tile__content__sub__header__text__bottom">
													<div className="request__myPitstop-cols">
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						}

						{isEnrolmentOfPrincipal &&
							<>
								<div className="layout-request__tile">
									<div className="layout-request__tile__content">
										<div className="layout-request__tile__content__header request-enrolment-confirmation-header">
											<div className="layout-request__title__content__header__left">
												<div className="request-title request-enrolment-confirmation-header-title">
													Selected Persona
												</div>
											</div>
											<div className="layout-request__title__content__header__right">
												<Button text="Edit" ghost submit={() => {
													goToStep(1)
												}} />
											</div>
										</div>
										<div className="enrolment-request__tile__content">
											<div className="layout-request__tile__content__sub__header">
												<div className="layout-request__tile__content__sub__header__icon">
													<IconMyPersona />
												</div>
												<div className="enrolment-request__tile__content__sub__header__text">
													<div className="layout-request__tile__content__sub__header__text__top">
														<div className="enrolment-request__systme-name">
															{currentPersonaItem?.name}
														</div>
													</div>
													<div className="layout-request__tile__content__sub__header__text__bottom">
														<div className="request__myPitstop-cols">
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div className="layout-request__tiles">
									<div className="layout-request__tile">
										<div className="layout-request__tile__content">
											<div className="layout-request__tile__content__header request-enrolment-confirmation-header">
												<div className="layout-request__title__content__header__left">
													<div className="request-title request-enrolment-confirmation-header-title">
														Selected Principal
													</div>
												</div>
												<div className="layout-request__title__content__header__right">
													<Button
														text="Edit"
														ghost
														submit={() => {
															goToStep(3);
														}}
													/>
												</div>
											</div>

											<div className="layout-request__title__content__rows">
												{renderSelectedRow(principalItems)}
											</div>
										</div>
									</div>
								</div>
							</>
						}

						<div className="layout-request__tile">
							<div className="layout-request__tile__content">
								<div className="layout-request__tile__content__header request-enrolment-confirmation-header">
									<div className="layout-request__title__content__header__left">
										<div className="request-title request-enrolment-confirmation-header-title">
											Selected System
										</div>
									</div>
									<div className="layout-request__title__content__header__right">
										<Button text="Edit" ghost submit={() => {
											isEnrolmentOfPrincipal ? goToStep(2) : goToStep(3)
										}} />
									</div>
								</div>

								<div className="layout-request__title__content__rows">
									{renderSelectedRow(systemItems)}
									{enrolmentType.toUpperCase() === EnrolmentTypes.provider && providerPitstopList.length > 0 && (
										<div className="layout-request__tile__content__row">
											<div data-testid="note-msg" className="enrolment-request__note-banner">
												<span className="enrolment-request__note-banner__text--bold">{"Note: "}</span>
												<span className="enrolment-request__note-banner__text">A copy of the data element will be sent to the selected pitstop when data provider shares this Data Element on behalf of your organization.</span>
											</div>
										</div>
									)}
								</div>
							</div>
						</div>

					</div>
				</div>

			</div>
		)
	}

	/*=================================================
		Navigate
	/================================================*/

	function onBack() {
		goTo(-1)
	}

	/*=================================================
		Additional
	/================================================*/

	async function fetchDataElement(personaId) {
		const getDataElement = {
			useCaseId: useCaseId,
			personaId: personaId ? personaId : currentPersonaItem.id,
			type: enrolmentType.toUpperCase()
		}

		const dataElementsTemp = produce(await findDataElements(getDataElement), draft => {
			return orderBy(draft, [option => option.name], "asc")
		})

		setDataElements(dataElementsTemp)
	}

	async function getPitstop() {
		if (!systemItems.some(item => item.$selected === true)) {
			await fetchSystem()
		}
	}

	async function fetchSystem(item) {
		setSystem([])
		const params = {
			useCaseId: useCaseId,
			dataElementId: currentDataElement?.id,
			type: enrolmentType,
		};
		const data = await fetchDataElementsDetail(params);
		setCurrentItem(data);

		let getSystems = {
			useCaseId: useCaseId,
			dataElementId: currentDataElement?.id,
			type: enrolmentType.toUpperCase()
		}

		if (
			enrolmentType.toUpperCase() === EnrolmentTypes.provider
			|| enrolmentType.toUpperCase() === EnrolmentTypes.consumer
		) {
			getSystems = {
				...getSystems,
				of: "ALL"
			}
		}

		const systems = await findSys(getSystems)

		if (isEnrolmentOfPrincipal) {
			const updatedSystem = data?.system.filter(obj => obj.enrolStatus === "APPROVED");
			const updatedPitstop = systems?.filter(objFromA => !updatedSystem?.find(objFromB => {
				return objFromA.id === objFromB.id
			}))

			if (updatedPitstop.length === 1) {
				const updatedItems = produce(updatedPitstop, draft => {
					draft[0].$selected = !draft[0].$selected
				})

				const updatedSysList = getSystemList(
					updatedItems,
					pitstopList,
					enrolmentType,
				);

				setSystem(updatedSysList)
			} else {
				setSystem(updatedPitstop)
			}
		} else {
			setSystem(systems)
		}
	}

	async function confirm() {
		if (loading) {
			return
		}

		setLoading(true)

		const getSystemIds = systemItems.filter(sys => sys.$selected === true).map(sys => sys.id)
		const getOrganisationIds = systemItems.filter(sys => sys.$selected === true).map(sys => sys.organisation.id)

		const systemPayload = getSystemIds.map(id => {
			return {
				useCaseId: useCaseId,
				dataElementId: currentDataElement?.id,
				systemId: id,
				orgId: user.organizationId,
				type: enrolmentType.toUpperCase(),
			}
		})

		const payload = systemPayload.map(item => {
			const sysItem = systemItems.filter(sys => sys.id === item.systemId)
			if (sysItem[0].hasOwnProperty('$ccToContributor')) {
				item = { ...item, ccToContributor: sysItem[0].$ccToContributor, contributorSystemId: sysItem[0].contributorSystemId }
			}
			if (isEnrolmentOfPrincipal) {
				item = { ...item, enrolmentPrincipals: principalItems.filter(p => p.$selected).map(p => ({ principalId: p.id })) }
			}
			return item
		})

		const [error, result] = await API_ENROLMENTS.create(payload)

		setLoading(false)

		if (error) {
			return addToastMessage(error?.message, toastType.error)
		}

		let dataInfo

		if (getOrganisationIds.some(organisation => organisation !== user.organizationId)) {
			dataInfo = {
				type: "provider",
			}

			return goTo(`/use-cases/${useCaseId}/enrolment/success`, dataInfo)
		}

		dataInfo = {
			type: 'no-provider',
			dataElement: currentDataElement.name
		}

		goTo(`/use-cases/${useCaseId}/enrolment/success`, dataInfo)
	}

	function getTypeName() {
		if (enrolmentType.toUpperCase() === EnrolmentTypes.provider) {
			return "contribute";
		} else if (enrolmentType.toUpperCase() === EnrolmentTypes.consumer) {
			return "consume";
		} else if (enrolmentType.toUpperCase() === EnrolmentTypes.provideOnBehalf) {
			return "provide on behalf of";
		} else if (enrolmentType.toUpperCase() === EnrolmentTypes.consumeOnBehalf) {
			return "consume on behalf of";
		}
		if (enrolmentType.toUpperCase() === EnrolmentTypes.provideOnBehalfOfPrincipal) {
			return "provide on behalf (Principal)"
		}
		if (enrolmentType.toUpperCase() === EnrolmentTypes.consumeOnBehalfOfPrincipal) {
			return isAgentPrincipalPhase2Enabled ? "consume on behalf (Principal)" :  "consume as agent for"
		}
	}

	return (
		<>
			<div className="title-header">
				<div className="title-header__left">
					<div className="title-header__title">{pageTitle}</div>
				</div>
				<div className="title-header__right">
				</div>
			</div>


			<Stepper steps={steps} currentStep={step-1}/>
			<hr />

			{isEnrolmentOfPrincipal ?
				<>
					{step === 1 &&
						<>
							<div className="layout-default__desc__data__element">Basic Configuration</div>
							<BasicConfiguration personaItem={personaItems} dataElementItem={dataElementsItems} />
						</>

					}

					{step === 2 &&
						<>
							<div className="layout-default__desc__data__element">Choose Pitstop to {getTypeName()} for {currentDataElement?.name}{!isAgentPrincipalPhase2Enabled ? ' with' : '.' }</div>
							<SystemList dataItem={systemItems} />
						</>
					}

					{step === 3 &&
						<>
							{isAgentPrincipalPhase2Enabled && <div className="font-weight-bold">Select Principal: </div>}
							<div className="use-cases__search__box" style={isAgentPrincipalPhase2Enabled ? { marginTop: rem(18) }: {}}>
								<Input
									maxWidth="334"
									fullWidth
									placeholder="Search by Principal name or UEN"
									prefix={<IconSearch />}
									value={searchBoxValue || ""}
									onChange={(e) => { handleSearch(e) }}
									cancelIcon={<IconClose />}
								/>
								<div>
									{principalItems?.filter(s => s?.$selected)?.length > 0 && (
										<span className={isAgentPrincipalPhase2Enabled ? "font-weight-bold" : ""}>{principalItems?.filter(s => s?.$selected)?.length || 0} Selected</span>
									)}
								</div>
							</div>
							<PrincipalTableList
								principals={principalItems}
								setPrincipals={setPrincipalItems}
								searchPrincipal={searchBoxValue}
								pagination={true}
								titleHeader="Principals"
							/>
						</>
					}

					{step === 4 &&
						<>
							<Confirmation />
						</>
					}
				</>
				:
				<>
					{step === 1 &&
						<>
							<div className="layout-default__desc__data__element">Select Persona</div>
							<PersonaList dataItem={personaItems} />
						</>
					}

					{step === 2 &&
						<>
							<div className="layout-default__desc__data__element">Choose Data Element</div>
							<DataElementList dataItem={dataElementsItems} />
						</>
					}

					{step === 3 &&
						<>
							<div className="layout-default__desc__data__element">Choose Pitstop to {getTypeName()} {currentDataElement?.name}{!isAgentPrincipalPhase2Enabled ? ' with' : '.' }</div>
							<SystemList dataItem={systemItems} />
						</>
					}

					{step === 4 &&
						<>
							<Confirmation />
						</>
					}
				</>
			}
			<div className='DS__layout__footer'>
				<div className="layout-default__sticky-actions">
					<div className="layout-default__sticky-actions__left">
						<div className="layout-default--margin-right">
							{isEnrolmentOfPrincipal ?
								<Button text="Cancel" ghost noborder submit={() => onBack()} />
								:
								<Button text="Cancel" noborder submit={() => onBack()} />
							}
						</div>
					</div>
					<div className="layout-default__sticky-actions__right layout-default--flex">

						{step > 1 &&
							<div className="layout-default--margin-right">
								<Button text="Previous" ghost submit={() => {
									prevStep()
								}} />
							</div>
						}

						{isEnrolmentOfPrincipal ?
							<>
								{step === 1 &&
									<Button text="Next"
										disabled={
											(!personaItems.some(item => item.$selected === true) || !dataElementsItems.some(item => item.$selected === true))
										}
										submit={async () => {
											try {
												nextStep()
												await getPitstop()
											} catch (err) {
												console.log({ err });
											}
										}} />
								}

								{step === 2 &&
									<Button text="Next"
										disabled={
											!systemItems.some(item => item.$selected === true)
										}
										submit={async () => {
											try {
												nextStep()
												getSortedData();
											} catch (err) {
												console.log({ err });
											}
										}} />
								}

								{step === 3 &&
									<Button text="Next"
										disabled={
											!principalItems.some((item) => item.$selected === true)
										}
										submit={() => {
											nextStep()
										}} />
								}

								{step === steps.length &&
									<Button sizing='Medium' text='Submit' full maxWidth='154'
										submit={() => confirm()}
										id="add-data-element-submit-button"
										disabled={isSubmitBtnDisabled(
											loading,
											enrolmentType,
											selectedSystem,
											pitstopList,
										)}
										loading={loading}
									/>
								}

							</>
							:
							<>
								{step === 1 &&
									<Button text="Next"
										disabled={
											!personaItems.some(item => item.$selected === true)
										}
										submit={async () => {
											try {
												nextStep()
												await fetchDataElement()
												// addAllToConsume()
											} catch (err) {
												console.log({ err });
											}
										}} />
								}

								{step === 2 &&
									<Button text="Next"
										disabled={
											!dataElementsItems.some(item => item.$selected === true)
										}
										submit={async () => {
											try {
												nextStep()
												await fetchSystem()
												// addAllToConsume()
											} catch (err) {
												console.log({ err });
											}
										}} />
								}

								{step === 3 &&
									<Button text="Next"
										disabled={
											!systemItems.some(item => item.$selected === true)
										}
										submit={() => {
											nextStep()
											// addAllToConsume()
										}} />
								}

								{/* {step > 0 && step !== steps.length &&
								<Button disabled={shouldGoNextStep} sizing='Medium' text='Next' full maxWidth='154'
									submit={() => {
										nextStep()
									}}
									// disabled={(step === 1 && !currentDataElement) || (step === 2 && !currentParticipant)}
								/>
							} */}

								{step === steps.length &&
									<Button sizing='Medium' text='Submit' full maxWidth='154'
										submit={() => confirm()}
										id="add-data-element-submit-button"
										disabled={isSubmitBtnDisabled(
											loading,
											enrolmentType,
											selectedSystem,
											pitstopList,
										)}
										loading={loading}
									/>
								}
							</>
						}
					</div>
				</div>
			</div>

			<PersonaInfoModal
				visible={visiblePersonaInfo}
				hide={hidePersonaInfo}
				persona={currentPersonaItem} />

			<Modal visible={visibleDataElementInfo} variant="medium" close={hideDataElementInfo}>
				<CardConfigure>
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__left">
										<div className={'card-configure__icon'}>
											<div className='persona-info-modal__icon'><IconData /></div>
										</div>
									</div>
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											{currentDataElement?.name || "-"}
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<div className="persona-info-modal">
								<div className="persona-info-modal__description">
									{currentDataElement?.description || "-"}
								</div>
								<hr />
								<div className="persona-info-modal__data-element">
									<div className="persona-info-modal__data-element-content">
										<div className="persona-info-modal__title ">
											Mandatory Data Fields
										</div>
										{
											currentDataElement?.requiredFields?.length > 0 ?
												currentDataElement?.requiredFields.map((item, index) => (
													<div className="layout-card__content_row" key={index}>
														<div className="layout-card__content__text">
															{item.name}
														</div>
													</div>
												))
												:
												<div className="layout-card__content_row">
													<div className="layout-card__content__text">
														No required data
													</div>
												</div>
										}
									</div>
									<div className="persona-info-modal__consume-data-element">
										<div className="persona-info-modal__title">
											Optional Data Fields
										</div>
										{
											currentDataElement?.optionalFields?.length > 0 ?
												currentDataElement?.optionalFields.map((item, index) => (
													<div className="layout-card__content_row" key={index}>
														<div className="layout-card__content__text">
															{item.name}
														</div>
													</div>
												))
												:
												<div className="layout-card__content_row">
													<div className="layout-card__content__text">
														No optional data
													</div>
												</div>
										}
									</div>
								</div>
							</div>
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
				</CardConfigure>
			</Modal>

			<Modal visible={visibleSystemInfo} variant="medium" close={hideSystemInfo}>
				<CardConfigure >
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__left">
										<div className='persona-info-modal__icon'><IconGear /></div>
									</div>
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											About {currenSystemItem?.systemName || "-"}
										</div>

									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<div className="persona-info-modal">
								<div className="persona-info-modal__title">
									Provider by {currenSystemItem?.organisation?.name || "-"}
								</div>
								<div className="persona-info-modal__value">
									<div className="layout-card__content__text">
										{currenSystemItem?.description || "-"}
									</div>
								</div>
							</div>
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
				</CardConfigure>
			</Modal>

			<Modal visible={IsVisibleCancel} variant="medium" close={hideCancel}>
				<CardConfigure >
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											Cancel Simulation
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<div style={{ fontSize: rem(14), textAlign: 'center' }}>Are you sure you want to cancel Simulation?</div>
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
					<CardConfigure.Footer>
						<CardConfigure.Footer.Right>
							<Button ghost text="Cancel"
								submit={() => {
									hideCancel()
								}} />
							<span style={{ width: rem(10), display: 'inline-block' }}></span>
							<Button text="Confirm"
								submit={() => {
									hideCancel();
									goTo(-1)
								}} />
						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal>

			<Toast toastList={toastList} />
		</>
	)
}
export default Page
